import React from "react";
import OwayLogo from "../../assets/images/owayLogo.svg";

export const Logo: React.FC = () => {
  return (
    <div className="flex items-center justify-center mb-8">
      <img src={OwayLogo} alt="Oway Logo" className="h-16 w-auto" />
    </div>
  );
};
